import './styles/mobidawg-style.scss';
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import AuthProvider from './pages/Authentication/AuthContext.jsx';
import { Box } from '@mui/material';
import theme from './styles/theme';
import Home from './pages/Home/Home.jsx';
import HomeServicesSolutions from './pages/Home/HomeServicesSolutions.jsx';
import HomeIndustries from './pages/Home/HomeIndustries.jsx';
import About from './pages/About/About.jsx';
import ContactForm from './pages/ContactUs/ContactForm.jsx';
import ContactConfirmation from './pages/ContactUs/ContactConfirmation.jsx';
import ContactRegistryList from './pages/ContactUs/ContactRegistryList.jsx';
import AddResourcePage from './pages/Resources/AddResourcePage.jsx';
import Privacy from './pages/Legal/Privacy.jsx';
import Terms from './pages/Legal/TermsAndConditions.jsx';
import Cookies from './pages/Legal/CookiesPolicy.jsx';
import Community from './pages/Community/Community.jsx';
import Support from './pages/Support/Support.jsx';
import Resources from './pages/Resources/Resources.jsx';
import ResourceList from './pages/Resources/ResoureListContent.jsx';
import ResourceModeration from './pages/Admin/ResourceModeration.jsx';
import ViewLogoAssets from './pages/Admin/ViewLogoAssets.jsx';
import ViewProductPages from './pages/Admin/ViewProductPages.jsx';
import TickerTest from './pages/Admin/TickerTest.jsx';
import AdminUserManagement from './pages/Admin/AdminUserManagement.jsx';
import AdminContactRegistry from './pages/ContactUs/AdminContactRegistry.jsx';
import ContactResponseForm from './pages/ContactUs/ContactResponseForm.jsx';
import SettingsPage from './pages/SettingsPage/SettingsPage.jsx';
import AccountProfile from './pages/AccountProfile/AccountProfile.jsx';
import AuthForm from './pages/Authentication/Signon.jsx';
import AuthorLanding from './pages/Author/AuthorLanding.jsx'
import DocumentNew from './pages/Author/DocumentNew.jsx'
import DocumentView from './pages/Author/DocumentView.jsx'
import DocumentEdit from './pages/Author/DocumentEdit.jsx'
import Error from './pages/Error/Error.jsx';
import RootLayout from './RootLayout.jsx';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  createRoutesFromElements,
  Navigate,
} from 'react-router-dom';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />} errorElement={<Error />}>
      <Route index element={<Home />} />
      <Route path="/home" element={<Navigate to="/" />} />
      <Route path="/servicesolutions" element={<HomeServicesSolutions />} />
      <Route path="/industries" element={<HomeIndustries />} />
      <Route path="/auth/signon" element={<AuthForm />} />
      <Route path="/contactform" element={<ContactForm />} />
      <Route path="/contactconfirmation" element={<ContactConfirmation />} />
      <Route path="/contactregistrylist" element={<ContactRegistryList />} />
      <Route path="/about" element={<About />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/legal/cookies" element={<Cookies />} />
      <Route path="/community" element={<Community />} />
      <Route path="/support" element={<Support />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/account" element={<AccountProfile />} />
      <Route path="/resources/add" element={<AddResourcePage />} />
      <Route path="/resources/resourcelist" element={<ResourceList />} />
      <Route path="/admin/resourcemoderation" element={<ResourceModeration />} />
      <Route path="/admin/viewlogoassets" element={<ViewLogoAssets />} />
      <Route path="/admin/viewproductpages" element={<ViewProductPages />} />
      <Route path="/admin/tickertest" element={<TickerTest />} />
      <Route path="/admin/contactregistrylist" element={<AdminContactRegistry />} />
      <Route path="/admin/contactresponseform" element={<ContactResponseForm />} />
      <Route path="/admin/usermanagement" element={<AdminUserManagement />} />
      <Route path="/author" element={<AuthorLanding />} />
      <Route path="/author/new" element={<DocumentNew />} />
      <Route path="/author/:docId" element={<DocumentView />} />
      <Route path="/author/:docId/edit" element={<DocumentEdit />} />
    </Route>
  )
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <RouterProvider router={router} />
        </Box>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
